import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { Button, HStack, Icon, IconButton, VStack } from "native-base";
import React, { useEffect, useState } from "react";

import SearchInput from "@/components/atoms/SearchInput";
import AppStatusBar from "@/components/atoms/StatusBar";

type HeaderWithSearchBarProps = {
  initialValue?: string;
  onBackPress: () => void;
  onChangeText: (text: string) => void;
};

const HeaderWithSearchBar = ({
  initialValue,
  onBackPress,
  onChangeText,
}: HeaderWithSearchBarProps) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  const onChange = (text: string) => {
    setValue(text);
    onChangeText(text);
  };

  const clearText = () => {
    setValue("");
    onChangeText("");
  };

  return (
    <VStack backgroundColor="white.50">
      <AppStatusBar />
      <HStack p="2" h="72px" pr="4" justifyContent="space-between" alignItems="center">
        <Button variant="ghost" onPress={() => onBackPress()}>
          <Icon as={<MaterialIcons name="arrow-back-ios" />} size="xl" color="primary.600" />
        </Button>
        <SearchInput
          value={value}
          flexGrow={1}
          autoFocus
          autoCorrect
          onChangeText={onChange}
          rightElement={
            <Button variant="ghost" rounded="full" onPress={clearText}>
              <Icon
                as={<MaterialCommunityIcons name="close-circle" />}
                size="md"
                color="gray.600"
              />
            </Button>
          }
        />
      </HStack>
    </VStack>
  );
};

export default HeaderWithSearchBar;
